import { Component, CUSTOM_ELEMENTS_SCHEMA, EventEmitter, inject, Input, OnInit, Output } from '@angular/core'
import { CommonModule } from '@angular/common'
import { FormsModule } from '@angular/forms'
import { IonicSelectableComponent } from 'ionic-selectable'
import { ClientDropdownService } from './client-dropdown.service'
import { Client } from '../../../models/client'

@Component({
  selector: 'app-client-dropdown',
  standalone: true,
  imports: [CommonModule, FormsModule, IonicSelectableComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './client-dropdown.component.html',
  styleUrls: ['./client-dropdown.component.scss'],
})
export class ClientDropdownComponent implements OnInit {
  private service = inject(ClientDropdownService)

  @Input() title = ''

  @Output() changed = new EventEmitter<Client>()

  selectedClient: Client

  clients$ = this.service.getAllClients()

  ngOnInit(): void {
    this.changed.emit(null)
  }
}
